import React from 'react';
import { Container } from '../../../../components/Container';
import { FaqsSection } from '../../../../components/FaqsSection';
import { Typography } from '../../../../components/Typography';
import { healthFaqsData } from '../../../../data';
import { Box } from '../../../../wag-react/next-components/box';
export const HealthFaqsSection = () => <Container data-sentry-element="Container" data-sentry-component="HealthFaqsSection" data-sentry-source-file="index.tsx">
    <Box maxWidth={['100%', null, '50%']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <FaqsSection items={healthFaqsData} pb="unset" px="unset" footerTextProps={{
      textAlign: 'start'
    }} headingProps={{
      textAlign: 'left'
    }} data-sentry-element="FaqsSection" data-sentry-source-file="index.tsx" />
      <Typography color="#AAAAAA" variant="legal" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        {'The Wag! Health services you receive from pet experts on the Wag! platform are not intended to establish or replace a veterinary client-patient relationship. There are potential risks associated with the use of these services. When using the Wag! Health services, you understand the additional risks and waive any liability to Wag!. If your pet is experiencing an emergency or has an urgent medical need, you should visit an emergency room or contact your primary veterinary clinic immediately.'}
      </Typography>
    </Box>
  </Container>;